import React, { useEffect, useState } from "react";
import cx from "classnames";
import { InputFilterStyled } from "./styled";
import moment from "moment";
import { Icons, Inputs, Buttons } from "components";

const InputFilter = ({
  theme_standard_input_filter,
  dataFilter,
  onQueryFilter,
  btnLabel,
  batnSaveLabel,
  onExport,
  onImport,
  onSave,
  onAnnounch,
}) => {
  const customClass = cx({
    theme_standard_input_filter: theme_standard_input_filter,
  });

  const [_filter, _setFilter] = useState({});

  useEffect(() => {
    if (dataFilter) {
      let temp = {};
      dataFilter.forEach((e) => {
        if (e.filter?.defaultValue) {
          switch (e.filter.type) {
            case "dateRank":
              temp = {
                ...temp,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: `start_date=${e.filter.defaultValue.startDate}&end_date=${e.filter.defaultValue.endDate}`,
                },
              };
              break;
            case "dateGroup":
              // level2 อาจเป็น Date object หรือ string (สำหรับ quarter)
              let startDate, endDate;
              if (e.filter.defaultValue.level2 instanceof Date) {
                // สำหรับ month, year - level2 เป็น Date object
                if (e.filter.defaultValue.level1 === "month") {
                  startDate = moment(e.filter.defaultValue.level2).startOf("month").format("YYYY-MM-DD");
                  endDate = moment(e.filter.defaultValue.level2).endOf("month").format("YYYY-MM-DD");
                } else if (e.filter.defaultValue.level1 === "year") {
                  startDate = moment(e.filter.defaultValue.level2).startOf("year").format("YYYY-MM-DD");
                  endDate = moment(e.filter.defaultValue.level2).endOf("year").format("YYYY-MM-DD");
                } else {
                  startDate = moment(e.filter.defaultValue.level2).format("YYYY-MM-DD");
                  endDate = moment(e.filter.defaultValue.level2).format("YYYY-MM-DD");
                }
              } else if (typeof e.filter.defaultValue.level2 === "string") {
                // สำหรับ quarter - level2 เป็น string "start_date=...&end_date=..."
                // ไม่ต้องทำอะไร ใช้ค่าเดิม
                startDate = e.filter.defaultValue.level2;
                endDate = null; // flag ว่าเป็น string format แล้ว
              }
              
              temp = {
                ...temp,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: endDate !== null 
                    ? `period=${e.filter.defaultValue.level1}&start_date=${startDate}&end_date=${endDate}`
                    : `period=${e.filter.defaultValue.level1}&${startDate}`,
                },
              };
              break;

            default:
              temp = {
                ...temp,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: e.filter.defaultValue,
                },
              };
              break;
          }
        }
      });
      _setFilter(temp);
    }
  }, [dataFilter]);

  const clickFilter = () => {
    if (Object.keys(_filter).length === 0) {
    } else {
      let queryArr = [];
      let query = "";
      Object.keys(_filter).forEach((key) => {
        if (
          (_filter[key].value || _filter[key].value === "") &&
          _filter[key].type !== "dateRank"
        ) {
          // Skip if value is empty string (means "All" selected in dropdown)
          if (
            _filter[key].value === "" ||
            _filter[key].value === null ||
            _filter[key].value === undefined
          ) {
            if (_filter[key].type === "dateGroup") {
              queryArr.push(`start_date=&end_date=`);
            }
            // Don't add parameter for other types with empty value
          } else {
            // สำหรับ dateGroup ไม่ต้อง encode เพราะค่ามี query string อยู่แล้ว
            if (_filter[key].type === "dateGroup") {
              queryArr.push(_filter[key].value);
            } else {
              queryArr.push(
                `${_filter[key].fieldQuery}=${encodeURIComponent(
                  _filter[key].value
                )}`
              );
            }
          }
        } else {
          queryArr.push(`${_filter[key].value}`);
        }
      });
      if (queryArr.length > 0) {
        query = `?${queryArr.join("&")}`;
      }
      onQueryFilter && onQueryFilter(query);
    }
  };

  const renderFilter = (e) => {
    switch (e.filter.type) {
      case "text":
        return (
          <Inputs.TextField
            defaultValue={e.filter.defaultValue}
            label={e.filter.label}
            placeholder={e.filter.placeholder && e.filter.placeholder}
            onChange={(f) => {
              _setFilter({
                ..._filter,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: f.target.value,
                },
              });
            }}
          />
        );

      case "date":
        return (
          <Inputs.DateTime
            theme_filter
            label={e.filter.label}
            placeholder={e.filter.placeholder && e.filter.placeholder}
            onChange={(f) => {
              _setFilter({
                ..._filter,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: moment(f).format("YYYY-MM-DD"),
                },
              });
            }}
          />
        );

      case "dropdown":
        return (
          <Inputs.Dropdown
            value={e.filter.defaultValue}
            label={e.filter.label}
            iconSvgClose={<Icons.ArrowDropDown />}
            iconSvgOpen={<Icons.ArrowDropDown up />}
            placeholder={e.filter.placeholder}
            options={e.filter.options}
            onChange={(f) => {
              _setFilter({
                ..._filter,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: f,
                },
              });
            }}
          />
        );

      case "dateRank":
        return (
          <Inputs.InputDatePickerBetween
            value={e.filter.defaultValue}
            label={e.filter.label}
            startDatePlaceholder="เริ่ม"
            endDatePlaceholder="สิ้นสุด"
            onChange={(f) => {
              _setFilter({
                ..._filter,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: `start_date=${moment(f.startDate).format(
                    "YYYY-MM-DD"
                  )}&end_date=${moment(f.endDate).format("YYYY-MM-DD")}`,
                },
              });
            }}
          />
        );
      case "dateGroup":
        return (
          <Inputs.DateGroup
            initialValues={e.filter.defaultValue}
            label={e.filter.label}
            iconSvgClose={<Icons.ArrowDropdown />}
            iconSvgOpen={<Icons.ArrowDropdown up />}
            placeholder={e.filter.placeholder}
            options={e.filter.options}
            onChange={(f) => {
              _setFilter({
                ..._filter,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: f,
                },
              });
            }}
          />
        );
      case "multiSelect":
        return (
          <Inputs.InputMultiSelect
            label={e.filter.label}
            options={e.filter.options}
            placeholder={e.filter.placeholder && e.filter.placeholder}
            onChange={(f) => {
              let joinString = "";
              f.forEach((g, i) => {
                joinString += g.value;
                if (f.length - 1 !== i) {
                  joinString += ",";
                }
              });
              _setFilter({
                ..._filter,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: joinString,
                },
              });
            }}
          />
        );
      default:
        break;
    }
  };

  return (
    <InputFilterStyled>
      <div className={customClass}>
        {dataFilter &&
          dataFilter.map((e, i) => (
            <div key={i}>
              <div key={i + 1} className="box_filter">
                {e.label && <div className="label_top">{e.label}</div>}
                <div key={i} style={{ width: `${e.length}` }}>
                  {renderFilter(e)}
                </div>
              </div>
            </div>
          ))}
        {dataFilter && dataFilter.length > 0 && (
          <div className="btn_action_filter">
            <Buttons.BgStandard
              label={btnLabel}
              height="100%"
              onClick={clickFilter}
            />
          </div>
        )}
        {onExport && (
          <div className="btn_action_filter">
            <Buttons.BgStandard
              theme_export_btn
              label={"Export"}
              height="100%"
              onClick={onExport}
            />
          </div>
        )}
        {onImport && (
          <div className="btn_action_filter">
            <Buttons.BgStandard
              theme_stadard_btn
              label={"Import"}
              height="100%"
              onClick={onImport}
            />
          </div>
        )}
        {onSave && (
          <div className="btn_action_filter">
            <Buttons.BgStandard
              theme_green
              label={batnSaveLabel || "Save"}
              height="100%"
              onClick={onSave}
            />
          </div>
        )}
        {onAnnounch && (
          <div className="btn_action_filter">
            <Buttons.BgStandard
              theme_green
              label={"Announce"}
              height="100%"
              onClick={onAnnounch}
            />
          </div>
        )}
      </div>
    </InputFilterStyled>
  );
};

InputFilter.propTypes = {};

export default InputFilter;
